import React, { useEffect, useState } from 'react';
import { tone } from '../../lib/score';

// Overall score: ring fills and the number counts up on first paint.
const ScoreRing = ({ score, size = 200, label = 'out of 100' }) => {
  const [shown, setShown] = useState(0);
  useEffect(() => {
    const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { setShown(score); return undefined; }
    let raf;
    const t0 = performance.now();
    const run = (now) => {
      const k = Math.min(1, (now - t0) / 1100);
      setShown(score * (1 - (1 - k) ** 3));
      if (k < 1) raf = requestAnimationFrame(run);
    };
    raf = requestAnimationFrame(run);
    return () => cancelAnimationFrame(raf);
  }, [score]);

  const stroke = 12;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const t = tone(score);
  return (
    <div className="relative inline-grid place-items-center" style={{ width: size, height: size }} data-testid="score-ring">
      <div className="absolute inset-6 rounded-full blur-2xl" style={{ background: `${t.hex}22` }} />
      <svg width={size} height={size} className="-rotate-90" aria-hidden="true">
        <circle cx={size / 2} cy={size / 2} r={r} stroke="rgba(255,255,255,0.06)" strokeWidth={stroke} fill="none" />
        <circle
          cx={size / 2} cy={size / 2} r={r}
          stroke={t.hex} strokeWidth={stroke} fill="none" strokeLinecap="round"
          strokeDasharray={c} strokeDashoffset={c - (shown / 100) * c}
        />
      </svg>
      <div className="absolute flex flex-col items-center">
        <span className={`text-6xl font-semibold tabular-nums tracking-tight ${t.text}`} data-testid="overall-score-value">
          {Math.round(shown)}
        </span>
        <span className="mt-1 text-[11px] uppercase tracking-[0.2em] text-white/40">{label}</span>
      </div>
    </div>
  );
};

export default ScoreRing;
